export {
  default as basement,
  ReactComponent as Basement,
} from '@assets/icons/features-and-amenities/basement.svg'    
